module.exports = __webpack_public_path__ + "img/共享交流-banner_02.7158d90e.jpg";